<template>
	<div :class="myimg">
		<top-image :myimg="myimg"></top-image>
		<div class="rs-main-wrapper">
			<div class="wrapper-title">
				<span :class="'a' + index" v-for="(item,index) in responsibilityWord">{{item}}</span>
			</div>
			<div class="chapter">
				<span :class="'a' + index" v-for="(item,index) in responsibilityWord1">{{item}}</span>
				<div class="fleximg">
					<img :src="'static/image/respon-img/' + item + '.jpg'" class="chapter-img" v-for="item in mainimg1">
				</div>
			</div>
			<div class="chapter">
				<span :class="'a' + index" v-for="(item,index) in responsibilityWord2">{{item}}</span>
				<img :src="'static/image/respon-img/' + item + '.jpg'" class="chapter-img2" v-for="item in mainimg2">
			</div>
			<div class="chapter">
				<span :class="'a' + index" v-for="(item,index) in responsibilityWord3">{{item}}</span>
				<img :src="'static/image/respon-img/' + item + '.jpg'" class="chapter-img3" v-for="item in mainimg3">
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import TopImage from 'components/top-image/top-image'


	export default {
		data() {
			return {
				myimg: 'Responsibility',
				mainimg1: [1,2],
				mainimg2: [3],
				mainimg3: [4]
			}
		},
		created() {
			// this._getResponsibilityword()
		},
		methods: {
			// _getResponsibilityword() {
			// 	this.$axios.get(api).then((res) => {
			// 	this.responsibilityWord = res.data
			// 	console.log(res.data)
			// 	})
			// }
		},
		computed: {
			responsibilityWord() {
				return this.$t('maintitle')
			},
			responsibilityWord1() {
				return this.$t('chapter10')
			},
			responsibilityWord2() {
				return this.$t('chapter11')
			},
			responsibilityWord3() {
				return this.$t('chapter12')
			}
		},
		components:{
			TopImage
		}
	}
</script>

<style scroped lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.rs-main-wrapper
		width: 80%
		margin: 80px auto
		.wrapper-title
			display: block
			.a0
				display: block
				font-size: $font-web-medium
				color: $color-theme
				border-bottom: 1px solid $color-theme
				margin-bottom: 10px
			.a1
				font-size: $font-web-small
			.a2
				display: block
				padding-top: 30px
				border-top: 1px solid $color-theme
				font-size: $font-web-small
		.chapter
			width: 90%
			margin: 60px auto
			font-size: $font-web-small
			.a0
				display: block
				font-size: $font-web-medium
				color: $color-theme
				border-bottom: 1px solid $color-theme
			.a1, .a2, .a3, .a4
				font-size: $font-web-small
				display: block
				margin-top: 10px
			.fleximg
				display: block
				margin: 0 auto
				.chapter-img
					width: 45%
					padding-top: 20px
					margin-right: 10%
				.chapter-img:nth-child(2)
					margin: 0
			.chapter-img2
				width: 40%
				margin: 30px auto
				display: block
			.chapter-img3
				width: 65%
				margin: 30px auto
				display: block
</style>



// WEBPACK FOOTER //
// src/components/Responsibility/Responsibility.vue